import React, { useEffect, useState } from "react";
import { Row, Col, Modal, ModalHeader, ModalBody } from "reactstrap";
import CardItem from "../CardItem";
import HomeService from "services/Website/HomeService";
import { useSelector, useDispatch } from "react-redux";
import Paginator from "../Paginator";
import { useTranslation } from "react-i18next";

const ModalComparison = ({
	modal,
	toggle,
	comparedCompound,
	AddToSelectedCompounds,
	history,
}) => {
	const { t } = useTranslation();
	const AuthData = useSelector((state) => state.Auth);
	const homeService = new HomeService();
	const [filtersParams, setFilterParams] = useState(null);
	const [compoundList, setCompoundList] = useState([]);
	const filterData = useSelector((state) => state.filter);
	const [pageOptions, setPageOptions] = useState({
		sizePerPage: 10,
		totalSize: 1,
	});

	const AddHandler = (compound) => {
		const updatedList = compoundList.filter(({ id }) => id !== compound.id);
		setCompoundList([...updatedList]);
		AddToSelectedCompounds(compound);
	};
	useEffect(() => {
		// debounce solution to reduce request data from api
		const timeoutId = setTimeout(() => {
			let params = {};
			if (filterData.compound?.trim().length)
				params["keyword"] = filterData.compound?.trim();
			params["budget"] = `${Math.round(filterData.budget[0])}-${Math.round(
				filterData.budget[1]
			)}`;
			params["area_sizs"] = `${Math.round(filterData.size[0])}-${Math.round(
				filterData.size[1]
			)}`;
			// if (filterData.bedRoom.trim().lenght) params["bedrooms"] = parseInt(filterData.bedRoom)
			if (filterData.location) params["location"] = filterData.location.value;
			// if (filterData.bathroom.trim().lenght) params["bathroom"] = parseInt(filterData.bathroom)
			if (filterData.paymentMethods.length)
				params["payment_type"] = filterData.paymentMethods.join();
			if (filterData.categories_ids.length)
				params["categories_ids"] = filterData.categories_ids
					.map((item) => item.value)
					.join();
			if (filterData.finishingType.length)
				params["finishing_type_ids"] = filterData.finishingType
					.map((item) => item.value)
					.join();
			if (filterData.unitType.length)
				params["unit_type_ids"] = filterData.unitType
					.map((item) => item.value)
					.join();
			if (filterData.bedrooms.length)
				params["bedrooms"] = filterData.bedrooms.join();
			if (filterData.bathrooms.length)
				params["bathrooms"] = filterData.bathrooms.join();
			if (filterData.delivery.length) params["delivery"] = filterData.delivery;

			setFilterParams({ ...params });
		}, 700);

		return () => clearTimeout(timeoutId);
	}, [filterData]);

	// useEffect(() => {
	//   const updatedData = compoundList ?.filter(({ id }) => !comparedCompound ?.some((item) => item.id === id))
	//                setCompoundList([...updatedData])
	// }, [comparedCompound])
	return (
		<Modal
			isOpen={modal}
			toggle={toggle}
			className={`${
				AuthData.lang !== "ar"
					? "modal-xl scrollbar-container mt-5"
					: "modal-xl scrollbar-container mt-5 ar-wrapper"
			}`}>
			<ModalHeader
				toggle={toggle}
				className="pt-0 d-flex  justify-content-between">
				{/* <h3 className='fw-bold text-primary'>Add to Comparison</h3> */}
				<p className="mb-0">{t("advance subtitle")}</p>
			</ModalHeader>
			<ModalBody>
				<Row className="mb-2 w-100">
					{compoundList?.map((compound, index) => {
						return (
							<Col lg={4} md={6}>
								<CardItem
									type="compare"
									key={index}
									compound={compound}
									AddToSelectedCompounds={AddHandler}
									history={history}
								/>
							</Col>
						);
					})}
				</Row>
				<Row className="d-flex justify-content-end">
					<Col className="d-flex justify-content-end" md={8} sm={12}>
						<Paginator
							service={homeService}
							pageOptions={pageOptions}
							setData={(data) => {
								const updatedData = data?.filter(
									({ id }) => !comparedCompound?.some((item) => item.id === id)
								);
								setCompoundList([...updatedData]);
							}}
							setCompareListData={() => {}}
							setPageOptions={setPageOptions}
							filtersParams={filtersParams}
							shouldGetData={false}
							setShouldGetData={() => {}}
						/>
					</Col>
				</Row>
			</ModalBody>
		</Modal>
	);
};

export default ModalComparison;
